import script from "./UsageStatisticsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UsageStatisticsModal.vue?vue&type=script&setup=true&lang=js"

import "./UsageStatisticsModal.vue?vue&type=style&index=0&id=595820a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-595820a9"]])

export default __exports__